import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { PageLoader } from "./PageLoader";

interface ClientRouteProps {
  children: ReactNode;
}

/**
 * Guard de route pour les pages réservées aux clients.
 */
export const ClientRoute = ({ children }: ClientRouteProps) => {
  const { isAuthenticated, user, isLoading } = useAuthStore();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== "CLIENT" && user?.role !== "ADMIN") {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

